export default {
    loadPosts(state,posts){
        console.log('Mutations', posts.length)
        state.posts = posts
    },
    updatePosts(state,posts){
        state.posts = posts
    },
    setErrors: (state,value)=> (state.errors = value ? value : [])
}